module.exports = __webpack_public_path__ + "static/media/getting-you-tax-file-number.f9e2587d.jpg";